export default __webpack_public_path__ + "static/media/img-greeting.324d2d21.svg";